import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex justify-center items-center z-[1000000000]">
      <AiOutlineLoading3Quarters className="text-blue-500 animate-spin text-6xl" />
    </div>
  );
};

export default LoadingOverlay;
